import React from "react";
import { Helmet } from "react-helmet";
import translator from '@/modules/i18n';

const $t = (key) => translator.$t(key)

const Application = ({ message = {}, url, imageURL, script, meta = [], viewport = true }) => {
  const metas = viewport ? [
    ...meta,
    { name: "viewport", content: "width=device-width, initial-scale=1, shrink-to-fit=no" }
  ] : meta

  return (
    <div className="application">
      <Helmet
        title={$t(message.title) || message.title}
        titleAttribute={{ itemprop: "name", lang: "en" }}
        meta={[
          { name: "description", content: $t(message.desc) || message.desc},
          { name: "robots", content: "index, follow" },
          { property: "og:title", content: $t(message.title) || message.title},
          { property: "og:type", content: "website" },
          { property: "og:url", content: url },
          { property: "og:image", content: imageURL },
          { property: "og:description", content: $t(message.desc) || message.desc},
          ...metas
        ]}
        link={[{ rel: "canonical", href: url }]}
        script={script}
      />
    </div>
  )
}

export default Application;

